module.exports = __webpack_public_path__ + "static/img/一起努力300x300.a65caa38.png";